import { render, staticRenderFns } from "./SeoDetailView.vue?vue&type=template&id=6f99ebae&scoped=true"
import script from "./SeoDetailView.vue?vue&type=script&lang=js"
export * from "./SeoDetailView.vue?vue&type=script&lang=js"
import style0 from "./SeoDetailView.vue?vue&type=style&index=0&id=6f99ebae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f99ebae",
  null
  
)

export default component.exports